import { RefObject, useRef, useState } from 'react';

import { GiHamburgerMenu as MenuIcon } from 'react-icons/gi';
import {
  BsBriefcaseFill as PortfolioIcon,
  BsFillEnvelopeFill as ContactIcon,
  BsHouseFill as HomeIcon,
  BsPersonFill as AboutIcon,
  BsTools as SkillsIcon,
} from 'react-icons/bs';
import { MdTimeline as TimelineIcon } from 'react-icons/md';

import Tooltip from './tooltip';
import MobileNavigation from './mobile-navigation';
import useMedia from 'use-media';
import { useActiveSectionContext } from '../context/active-section-context';

interface INavigationItem {
  navigateToId: string;
  icon: any;
  display: string;
  toRef?: RefObject<HTMLDivElement>;
}

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigationElement = useRef<HTMLDivElement>(null);
  const isMobile = useMedia({ maxWidth: 600 });
  const { activeSectionId, setActiveSectionId } = useActiveSectionContext();

  const toggleNavigation = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const navItems: INavigationItem[] = [
    { icon: HomeIcon, display: 'home', navigateToId: 'intro' },
    { icon: AboutIcon, display: 'about me', navigateToId: 'about' },
    { icon: SkillsIcon, display: 'my skills', navigateToId: 'skills' },
    { icon: TimelineIcon, display: 'career', navigateToId: 'career' },
    { icon: PortfolioIcon, display: 'portfolio', navigateToId: 'portfolio' },
    { icon: ContactIcon, display: 'contact', navigateToId: 'contact' },
  ];

  const handleNavigateByLink = (navigateToId: string) => {
    document.getElementById(navigateToId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {isMobile && (
        <button className="burger-menu-button" onClick={toggleNavigation} type="button">
          <MenuIcon />
        </button>
      )}
      <MobileNavigation
        isOpen={mobileMenuOpen && isMobile}
        onClose={() => setMobileMenuOpen(false)}
      />
      <nav className="navigation" ref={navigationElement}>
        {navItems.map((item, index) => (
          <Tooltip
            key={index}
            content={item.display}
            position="left"
            className="navigation-tooltip"
          >
            <button
              className={`navigation__item ${
                activeSectionId === item.navigateToId ? 'active' : ''
              }`}
              onClick={() => {
                setActiveSectionId(item.navigateToId);
                handleNavigateByLink(item.navigateToId);
              }}
            >
              {item.icon({ className: 'navigation__item__icon' })}
              <span className="navigation__item__description">{item.display}</span>
            </button>
          </Tooltip>
        ))}
      </nav>
    </>
  );
};

// TODO: rewrite burger menu logic

export default Navigation;
